const messages = {
	selected_reservation_date: 'Selected reservation date',
	change_date: 'Change date',
	reserve_with_voucher: 'Reserve with voucher(code)',
	redeem_your_vouchers_here: 'Redeem your vouchers here!',
	redeem_your_vouchers_and_gift_vouchers_during_payment_step:
		'Enter your unique voucher code(s) below. Gift cards can be redeemed at checkout.',
	cancel: 'Cancel',
	redeem: 'Redeem',
	voucher_code: 'Voucher Code',
	from: 'From',
	per_person_short: 'per person',
	starting_from_short: 'starting from',
	unable_to_redeem_voucher: 'Unable to redeem voucher',
	view: 'View details',
	book: 'Book',
	ok: 'OK',
	more_info: 'More info',
	swimwear_day: 'Swimwear day',
	filter_swimwear_days: 'Filter on swimwear days',
	add_extra_voucher: 'Add extra voucher',
	make_your_choice: 'Make your choice',
	choose_from_options: 'You can choose from {count} options',
	unavailable_in_active_locale_message: 'Attention: You will be redirected to our English website.',
	loading: 'Loading',
	reserve_with_bathcard: 'Reserve with bath card',
	i_have_a_gift_voucher: 'I have a gift voucher',
	back: 'Back',
	close: 'Close',
	more_information: 'More information',
	view_page: 'View page',
	choose: 'Choose',
	go_back: 'Go back',
	previous_option: 'Previous option',
	next_option: 'Next option',
	arrangements_and_deals: 'Packages & deals',
	choose_date: 'Choose date',
	clear_date: 'Clear the selected date',
	choose_arrival_date: 'Choose arrival date',
	prices_per_person: 'Prices are per person',
	prices_per_person_per_night: 'Prices are per person per night',
	availability_notice: 'There is still availability!',
};

export default messages;
